import {
  AutomationRuleApiInterface,
  AutomationRuleRemoveActionInterface,
  AutomationRuleSaveInterface,
  AutomationRulesState,
  AutomationRuleTogglePreventSavingInterface,
} from './automationRulesReducer'

export const FETCH_PAGE_AUTOMATION_RULES = 'FETCH_PAGE_AUTOMATION_RULES'
export const SAVE_AUTOMATION_RULE = 'SAVE_AUTOMATION_RULE'
export const REMOVE_AUTOMATION_ACTION = 'REMOVE_AUTOMATION_ACTION'
export const TOGGLE_AUTOMATION_RULE_PREVENT_SAVING =
  'TOGGLE_AUTOMATION_RULE_PREVENT_SAVING'
export const SAVE_AUTOMATION_RULES_STATE = 'SAVE_AUTOMATION_RULES_STATE'

export type FetchPageAutomationRules = {
  type: typeof FETCH_PAGE_AUTOMATION_RULES
  payload: AutomationRuleApiInterface[]
}

export type SaveAutomationRule = {
  type: typeof SAVE_AUTOMATION_RULE
  payload: AutomationRuleSaveInterface
}

export type RemoveAutomationAction = {
  type: typeof REMOVE_AUTOMATION_ACTION
  payload: AutomationRuleRemoveActionInterface
}

export type ToggleAutomationRulePreventSaving = {
  type: typeof TOGGLE_AUTOMATION_RULE_PREVENT_SAVING
  payload: AutomationRuleTogglePreventSavingInterface
}

export type SaveAutomationRulesState = {
  type: typeof SAVE_AUTOMATION_RULES_STATE
  payload: AutomationRulesState
}

export type AutomationRulesActions =
  | FetchPageAutomationRules
  | SaveAutomationRule
  | RemoveAutomationAction
  | ToggleAutomationRulePreventSaving
  | SaveAutomationRulesState
